import * as community from './types';

const mutations = {
  [community.SET_HOT_LIST](state, data) {
    state.hotList = data.content;
  },
  [community.SET_BOARD](state, data) {
    state.board = data;
  },
  [community.SET_BOARD_LIST](state, data) {
    state.boardList = data.content;
    state.boardCnt = data.pagination.totalElements;
  },
  [community.SET_BOARD_REPLY_LIST_MINE](state, data) {
    state.boardReplyListMine = data.content;
  },
  [community.SET_BOARD_REPLY_LIST](state, data) {
    state.boardReplyList = data.content;
  },
  [community.SET_KNOWHOW](state, data) {
    state.knowhow = data;
  },
  [community.SET_KNOWHOW_LIST](state, data) {
    state.knowhowList = data.content;
    state.knowhowCnt = data.pagination.totalElements;
  },
  [community.SET_KNOWHOW_ANSWER_LIST](state, data) {
    state.knowhowAnswerList = data.content;
  },
  [community.SET_KNOWHOW_ANSWER_DETAIL](state, data) {
    state.knowhowAnswerDetail = data;
  },
  [community.SET_KNOWHOW_REPLY_LIST](state, data) {
    state.knowhowReplyList = data.content;
  },
  [community.SET_KNOWHOW_REPLY_LIST_MINE](state, data) {
    state.knowhowReplyListMine = data.content;
  },
  [community.SET_HOT_POST_LIST](state, data) {
    state.hotPostList = data;
  },
};

export default mutations;
